import React, { ReactNode } from 'react';
import { Alert, LoadingSpinner } from 'vetrf-ui';
import { Grid } from '@mui/material';

type CheckDataLoadingProps = {
  children: ReactNode;
  condition: boolean;
};

export const CheckDataLoading = ({ children, condition }: CheckDataLoadingProps) => (
  <>
    {condition ? (
      children
    ) : (
      <Grid container>
        <Grid item xs={12}>
          <Alert messageType="info">
            <LoadingSpinner
              color="blue"
              icon="spinner"
              spin="spin"
              text="Информация загружается..."
            />
          </Alert>
        </Grid>
      </Grid>
    )}
  </>
);
